import React from "react";
import { useOutlet } from "react-router";

export const InstanceConfiguration = () => {
  const outlet = useOutlet();
  return <>{outlet || <h4>Edit Settings</h4>}</>;
};
